import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getToken, getFreshToken } from '../providers/firebaseAuth'

const rawBaseQuery = fetchBaseQuery({
  baseUrl: '/',
  prepareHeaders: async headers => {
    const token = await getToken()
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }

    return headers
  },
})

// A 401 can come from a stale/expired cached ID token rather than a genuinely
// invalid session (common for multi-tenant users switching tenants). Force a
// token refresh and retry once before letting the error reach rtkQueryErrorLogger,
// which logs the user out. A genuinely invalid token still 401s on retry and logs out.
const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions)
  if (result.error?.status !== 401) {
    return result
  }

  // If the refresh itself fails, fall through with the original 401 so
  // rtkQueryErrorLogger still logs the user out instead of swallowing the error.
  try {
    await getFreshToken()
  } catch {
    return result
  }

  return rawBaseQuery(args, api, extraOptions)
}

const api = createApi({
  reducerPath: 'apiReducer',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
})

export default api
